import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommunicationPreferences } from '../../models/api/core/comm-preferences/communication-preferences';
import { UpdateCommunicationPreferences } from '../../models/api/core/comm-preferences/update-communication-preferences';
import { ValidatorsEx } from '../../validators/validators-ex';
import { BaseComponent } from '../base/base.component';
import { ButtonComponent } from '../core/buttons/button.component';
import { InputComponent } from '../core/controls/input.component';
import { RadioButtonComponent } from '../core/controls/radio-button.component';
import { SelectComponent } from '../core/controls/select.component';
import { ActionRowComponent } from '../core/panels/action-row.component';
import { DialogComponent } from '../core/panels/dialog.component';
import { RequiredFieldsNoteComponent } from '../core/labels/required-fields-note.component';

@Component({
  selector: 'app-edit-preferences',
  imports: [
    RadioButtonComponent,
    InputComponent,
    SelectComponent,
    ActionRowComponent,
    ButtonComponent,
    RequiredFieldsNoteComponent,
  ],
  template: ` <div class="tw-p-3 md:tw-p-8 tw-flex tw-flex-wrap">
    <app-required-fields-note />
    <div
      class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 md:tw-gap-2 tw-items-center tw-w-full tw-mt-3 md:tw-mt-0"
    >
      <div class="tw-hidden md:tw-block"></div>
      <div class="tw-hidden md:tw-block"></div>
      <div class="tw-hidden md:tw-block"></div>
      <div>
        <app-select
          [control]="fg.controls.method"
          label="Method"
          optionLabel="method"
          optionValue="code"
          [options]="options"
          [filter]="false"
          [virtualScroll]="false"
        />
      </div>
      <div>
        <app-input
          [control]="fg.controls.value"
          label="Value"
          class="tw-flex tw-flex-wrap"
        />
      </div>
      <div>
        <app-radio-button
          [control]="fg.controls.useForAuth"
          label="Use for Authentication?"
          optionLabel="auth"
          optionValue="code"
          [options]="option"
        />
      </div>
    </div>

    <app-action-row class="tw-w-full"
      ><app-button right1 label="Save" (click)="savePreferences()" />
      <app-button right2 emphasis="Low" label="Cancel" (click)="close.emit()"
    /></app-action-row>
  </div>`,
  styles: ``,
})
export class EditPreferencesComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  updatedRow: UpdateCommunicationPreferences;
  error: any;
  contact: number;

  @Input()
  dataSource: CommunicationPreferences;

  @ViewChild('editPreferencesDialog')
  editPreferences: DialogComponent;

  @Output()
  close = new EventEmitter<CommunicationPreferences>();

  fg = new FormGroup({
    method: new FormControl<string>('', Validators.required),
    value: new FormControl<string>('', [Validators.required]),
    useForAuth: new FormControl<string>('', Validators.required),
  });
  options = [
    { method: 'Email', code: 'EMAIL' },
    { method: 'Text', code: 'TEXT' },
  ];
  option = [
    { auth: 'Yes', code: 'Y' },
    { auth: 'No', code: 'N' },
  ];

  ngOnInit(): void {
    this.dispose.subs = this.fg
      .get('method')
      ?.valueChanges.subscribe((value) => this.updateValueValidators(value));
    this.setFormControlValues(this.dataSource);
  }

  async savePreferences() {
    if (!this.fg.valid) {
      this.fg.markAllAsTouched();
      return;
    }
    this.updatedRow = {
      method: this.fg.value.method,
      value: this.fg.value.value,
      auth: this.fg.value.useForAuth,
      contactUid: this.dataSource.contactUid,
    };

    this.error = null;
    try {
      await this.api.communicationPreferences.update(this.updatedRow);
      this.dataSource = this.updatedRow;
      this.fg.reset();
      this.close.emit(this.dataSource);
    } catch (e) {
      this.error(e);
    }
  }

  updateValueValidators(value: string): void {
    const valueText = this.fg.get('value');
    if (value === 'EMAIL') {
      valueText?.setValidators([
        Validators.required,
        ValidatorsEx.email(this.fg.controls.value),
      ]);
    } else {
      valueText?.setValidators([
        Validators.required,
        ValidatorsEx.phone(this.fg.controls.value),
      ]);
    }
  }

  setFormControlValues(value: CommunicationPreferences) {
    this.fg.controls.method.setValue(value.method);
    this.fg.controls.value.setValue(value.value);
    this.fg.controls.useForAuth.setValue(value.auth);
    this.contact = value.contactUid;
  }
}
